export type GemiusRoute = {
	readonly identifier: string;
	readonly extra: string;
};

const GEMIUS_ID = '.RbrQGsvAM7jlsFoBVds0GXFXfa1dQbNjl8JrrjXGvj..7';

export const GEMIUS_PAGES = {
	// Only the very first page with logo and search in the middle of the page
	HOME: {
		identifier: GEMIUS_ID,
		extra: 'gA=sbazar.cz/vyhledavani/0-vsechny-kategorie/cela-cr/nejnovejsi/1',
	},
	// The page that is displayed after a search is performed, category selected/filtered, etc.
	// In IMA.js, we send the same `extra` even though the url is different with each filter, category, etc.
	SEARCH_PAGE: {
		identifier: GEMIUS_ID,
		extra: 'gA=sbazar.cz/vyhledavani/0-vsechny-kategorie/cela-cr/nejnovejsi/1',
	},
	// Only user offer detail, no zbozi.cz, eshop, etc.
	OFFER_DETAIL: {
		identifier: GEMIUS_ID,
		extra: 'gA=sbazar.cz/inzerat',
	},
	// Only when user looks at the offers of other user
	SELLER_OFFER_LIST: {
		identifier: GEMIUS_ID,
		extra: 'gA=sbazar.cz/ostatni',
	},
	// Only when user looks at the list of his own offers
	BAZAREK_OFFER_LIST: {
		identifier: GEMIUS_ID,
		extra: 'gA=sbazar.cz/moje-inzeraty/zverejnene',
	},
} as const;
